import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoaderComponent} from './loader.component';
import {LoaderService} from './loader.service';
import { SpinnerService } from './dipse-spinner/spinner.service';
import { SpinnerComponent } from './dipse-spinner/spinner.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        LoaderComponent,
        SpinnerComponent
    ],
    exports: [
        LoaderComponent,
        SpinnerComponent
    ],
    providers: [
        LoaderService,
        SpinnerService
    ]
})
export class LoaderModule {
}
